export const blockedURLs = [
  'linkedin.com',
  'instagram.com',
  'snapchat.com',
  'pinterest.com',
  'reddit.com',
  'twitter.com',
  'tiktok.com',
  'paypal.com',
  'citi.com',
  'bankofamerica.com',
  'wellsfargo.com',
  'chase.com',
  'ameritrade.com',
  'apple.com',
  'icloud.com',
  'gmail.com',
  'outlook.com',
  'live.com',
  'spotify.com',
  'shopify.com',
  'bing.com',
  'google.com',
  'facebook.com',
];

export const isURLBlockedByDemostack = (url: string): boolean => {
  return blockedURLs.some((blockedURL) => url.includes(blockedURL));
};
